import React from 'react';
import { ArrowLeftIcon, HeartPulseIcon } from 'lucide-react';
export function Disclaimer() {
  return <main className="min-h-screen w-full bg-[#fcfbf7] px-5 py-10 text-[#344833] sm:px-8 sm:py-16" data-id="element-444" data-mp="11vwiak27gq0d">
      <div className="mx-auto max-w-3xl" data-id="element-445" data-mp="16vivwuly489p">
        <a href="/" className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.12em] text-[#597050] transition-colors hover:text-[#30452e]" data-id="element-446" data-mp="16wk9b5qfp6ul">
          <ArrowLeftIcon size={16} data-id="element-447" data-mp="e8obtyt1jawr" />
          VOLVER A CÓDIGO FITNESS™
        </a>

        <article className="mt-12 border border-[#e1e4da] bg-[#fffefa] p-7 shadow-[0_12px_35px_rgba(61,75,53,0.07)] sm:p-12" data-id="element-448" data-mp="j79ahtsn9mj3">
          <div className="flex items-center gap-3 text-[#66805c]" data-id="element-449" data-mp="n6i7d7ize0iv">
            <HeartPulseIcon size={20} strokeWidth={1.5} aria-hidden="true" data-id="element-450" data-mp="rzjn1hr0i43i" />
            <p className="text-xs font-bold tracking-[0.2em]" data-id="element-451" data-mp="3rmjb0xgvyjor">
              INFORMACIÓN LEGAL
            </p>
          </div>
          <h1 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-452" data-mp="3vma9lncnm43u">
            Descargo de Responsabilidad
          </h1>

          <div className="mt-10 space-y-9 leading-8 text-[#5d6a59]" data-id="element-453" data-mp="1vobrgc1ogly4">
            <section data-id="element-454" data-mp="1vp3ntp33mnpg">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-455" data-mp="1vqo9ep7fqwb6">
                Finalidad educativa e informativa
              </h2>
              <p className="mt-3" data-id="element-456" data-mp="1lzabumz1o6ko">
                Código Fitness™ ofrece contenidos educativos e informativos
                relacionados con alimentación, recetas, organización de comidas
                y hábitos de bienestar. Su finalidad es brindar herramientas
                prácticas de consulta y no constituye asesoramiento médico
                individualizado.
              </p>
            </section>

            <section data-id="element-457" data-mp="130y2p184uwp3">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-458" data-mp="131h9blsc1ynt">
                No sustituye atención profesional
              </h2>
              <p className="mt-3" data-id="element-459" data-mp="2xdxeej9e76r3">
                El contenido de Código Fitness™ no sustituye el diagnóstico,
                tratamiento, consejo ni las recomendaciones de un médico,
                nutricionista, dietista u otro profesional de la salud
                cualificado. No debe utilizarse para diagnosticar, tratar, curar
                o prevenir ninguna enfermedad o condición médica.
              </p>
            </section>

            <section data-id="element-460" data-mp="qq6pmc67yjbd">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-461" data-mp="qnauevlra8qm">
                Resultados individuales
              </h2>
              <p className="mt-3" data-id="element-462" data-mp="1jdsv5pz0by0v">
                Cada persona puede experimentar resultados diferentes según su
                condición física, estado de salud, necesidades nutricionales,
                hábitos, contexto y compromiso personal. Código Fitness™ no
                promete ni garantiza resultados concretos.
              </p>
            </section>

            <section className="border-l-2 border-[#91a783] bg-[#f4f7ef] px-5 py-6" data-id="element-463" data-mp="3p5px7iljt9j2">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-464" data-mp="3u7oymmxq9wdd">
                Consulta antes de realizar cambios importantes
              </h2>
              <p className="mt-3" data-id="element-465" data-mp="279o2lekgmonc">
                Recomendamos consultar con un profesional de la salud antes de
                realizar cambios importantes en la alimentación o el estilo de
                vida, especialmente si tienes enfermedades, alergias,
                intolerancias, estás embarazada, en período de lactancia, tomas
                medicación o presentas cualquier condición médica preexistente.
              </p>
            </section>

            <section data-id="element-466" data-mp="1ogto0lqr0yjn">
              <h2 className="font-display text-2xl text-[#354a33]" data-id="element-467" data-mp="22ab8c8r9efaq">
                Uso responsable
              </h2>
              <p className="mt-3" data-id="element-468" data-mp="1xj2w74yjoftv">
                Al utilizar el contenido, aceptas hacerlo bajo tu propia
                responsabilidad y tomar decisiones informadas de acuerdo con tus
                necesidades particulares. Si tienes dudas sobre tu salud o tu
                alimentación, busca orientación profesional adecuada.
              </p>
            </section>
          </div>
        </article>

        <p className="mt-8 text-center text-xs text-[#7a8574]" data-id="element-469" data-mp="1nfzbkk0w8r1j">
          © 2026 Código Fitness™. Todos los derechos reservados.
        </p>
      </div>
    </main>;
}